import { useEffect, useMemo, useState } from "react";
import { db } from "../../firebaseConfig";
import {
  addDoc,
  collection,
  deleteDoc,
  doc,
  getDocs,
  limit,
  onSnapshot,
  orderBy,
  query,
  runTransaction,
  serverTimestamp,
  updateDoc,
  where,
  writeBatch,
  startAfter,
  getCountFromServer,
} from "firebase/firestore";
import toast, { Toaster } from "react-hot-toast";
import JSZip from "jszip";
import { saveAs } from "file-saver";
import jsPDF from "jspdf";
import { NOTO_GUJARATI_BASE64 } from "../../assets/fonts/notoGujaratiBase64";

const cx = (...xs) => xs.filter(Boolean).join(" ");

const STATUS_OPTIONS = [
  "NOT_CONTACTED",
  "EMAIL_QUEUED",
  "EMAIL_SENT",
  "COURIER_SENT",
  "BOTH_SENT",
  "APPLIED",
  "FOLLOWUP_REQUIRED",
];

/* ================== FIX START: FINAL LETTER EMAIL TEMPLATE ================== */
const FINAL_LETTER_EMAIL_HTML = `
<div style="font-family:Arial,Helvetica,sans-serif;font-size:14px;line-height:1.8;color:#111827;">
  <div style="border:1px solid #e5e7eb;border-radius:12px;padding:12px 14px;background:#ffffff;">
    <div style="font-size:13px;">
      <b>પત્ર ક્રમાંક:</b> {{LETTER_NO}} &nbsp;&nbsp;&nbsp; <b>તારીખ:</b> {{DATE}}
    </div>
    <div style="margin-top:6px;font-size:13px;">
      <b>આમંત્રણ કોડ (Invitation Code):</b> <span style="font-weight:800;">{{INVITATION_CODE}}</span>
    </div>
  </div>

  <div style="margin-top:14px;">
    <div><b>પ્રતિ,</b></div>
    <div><b>ચેરમેનશ્રી / સેક્રેટરીશ્રી / મેનેજરશ્રી,</b></div>
    <div style="margin-top:4px;font-weight:800;">{{SOCIETY_NAME}}</div>
    <div style="margin-top:2px;">{{LOCATION_LINE}}</div>
  </div>

  <div style="margin-top:14px;">
    <div style="font-weight:800;">વિષય:</div>
    <div style="margin-top:6px;">
      ભારત સરકારના સહકાર મંત્રાલય દ્વારા અમલમાં મુકાયેલ
      <b>“World’s Largest Grain Storage Plan in Cooperative Sector”</b>
      યોજનાઅંતર્ગત PACS/સહકારી સંસ્થાઓ દ્વારા અનાજ સંગ્રહ ગોડાઉન નિર્માણ માટે
      ઓનલાઈન અરજી કરવા બાબત.
    </div>
    <div style="border-top:1px solid #111827;margin-top:10px;"></div>
  </div>

  <div style="margin-top:12px;">
    ઉપરોક્ત વિષય સંદર્ભે આપને જાણ કરવામાં આવે છે કે ભારત સરકારના સહકાર મંત્રાલય દ્વારા સહકારી ક્ષેત્રમાં
    અનાજ સંગ્રહ ક્ષમતા વધારવા માટે ઉપરોક્ત યોજના અમલમાં મુકવામાં આવી છે.
  </div>

  <div style="margin-top:10px;">
    આ યોજનાની માર્ગદર્શિકા (Margdarshika) મુજબ પાત્ર સંસ્થાઓ દ્વારા <b>500 MT / 1000 MT અથવા તેથી વધુ</b>
    ક્ષમતાના આધુનિક અનાજ સંગ્રહ ગોડાઉન માટે અરજી કરી શકાય છે. પ્રોજેક્ટ મંજૂરી, Hiring Assurance,
    બેંક ફાઇનાન્સ તથા સબસિડી સંબંધિત પ્રક્રિયા સંબંધિત DCDC/સક્ષમ અધિકારીઓ દ્વારા લાગુ નિયમો મુજબ કરવામાં આવશે.
  </div>

  <div style="margin-top:14px;">
    <div style="font-weight:800;">યોજનાની મુખ્ય શરતો (Margdarshika મુજબ):</div>
    <ul style="margin:8px 0 0 18px;padding:0;">
      <li>500 MT / 1000 MT અથવા તેથી વધુ ક્ષમતાનો અનાજ સંગ્રહ ગોડાઉન.</li>
      <li>જમીન પોતાની હોય તો/અથવા DCDC મંજૂરી બાદ ઓછામાં ઓછા 20 (વીસ) વર્ષ માટે કાયદેસર લીઝ પર જમીન મેળવવા તૈયાર.</li>
      <li>DCDC મંજૂરી, Hiring Assurance, બેંક ફાઇનાન્સ તથા સબસિડી આધારિત સમયબદ્ધ અમલ.</li>
      <li>WDRA તથા અન્ય લાગુ સરકારી નિયમો/ગુણવત્તા ધોરણોનું પાલન.</li>
    </ul>
  </div>

  <div style="margin-top:14px;">
    <div style="font-weight:800;">અરજી કરવાની પદ્ધતિ (IMPORTANT):</div>
    <div style="margin-top:6px;">
      યોજનાની માર્ગદર્શિકા મુજબ અરજી ઓનલાઈન પોર્ટલ મારફતે જ કરવાની રહેશે. નીચેની લિંક દ્વારા અરજી કરી શકો છો:
    </div>

    <div style="margin-top:8px;">
      <a href="https://www.shineagri.org/apply-godown" target="_blank" style="font-weight:800;color:#0b63ce;">
        https://www.shineagri.org/apply-godown
      </a>
    </div>

    <div style="margin-top:8px;">
      <b>આમંત્રણ કોડ (Invitation Code):</b> <span style="font-weight:800;">{{INVITATION_CODE}}</span>
    </div>
  </div>

  <div style="margin-top:14px;">
    <div style="font-weight:800;">પ્રક્રિયા માર્ગદર્શન (PMC સપોર્ટ):</div>
    <div style="margin-top:6px;">
      યોજનાની અરજી પ્રક્રિયા, દસ્તાવેજીકરણ, DPR તૈયારી, સાઇટ વિઝિટ, DCDC સંકલન તથા અમલીકરણ દરમ્યાન
      જરૂરી માર્ગદર્શન/હેન્ડહોલ્ડિંગ માટે Project Management Consultant (PMC) તરીકે નીચે મુજબ સહાય ઉપલબ્ધ રહેશે:
    </div>
    <ul style="margin:8px 0 0 18px;padding:0;">
      <li>દસ્તાવેજ ચકાસણી તથા ઓનલાઈન અરજીમાં સહાય.</li>
      <li>DPR/Project Report તૈયાર કરાવવાની પ્રક્રિયામાં માર્ગદર્શન.</li>
      <li>Site Visit &amp; Technical Coordination (જરૂર મુજબ).</li>
      <li>DCDC/સંબંધિત સત્તાધિકારીઓ સાથે સમન્વય અને માર્ગદર્શન.</li>
      <li>યોજના મુજબ સમયબદ્ધ અમલ માટે જરૂરી માર્ગદર્શન.</li>
    </ul>

    <div style="margin-top:10px;border:1px solid #e5e7eb;border-radius:12px;background:#f8fafc;padding:10px 12px;">
      <div><b>PMC:</b> Shine Agri Allied &amp; Marketing Multistate Cooperative Society Limited</div>
      <div><b>Address:</b> 48, 1st Amar Arcade, Nilpur, Taluka-Dantiwada, Banaskantha, Gujarat-385505, India</div>
      <div><b>Email:</b> tender@shineagri.org</div>
      <div><b>Helpline:</b> 9274799225 / 761869225</div>
      <div><b>Coordination Partner:</b> GUJCOMASOL</div>
    </div>
  </div>

  <div style="margin-top:14px;">
    <div style="font-weight:800;">અરજી બાદ દસ્તાવેજ મોકલવા અંગે (Document Submission – PMC):</div>
    <div style="margin-top:6px;">
      ઓનલાઈન અરજી સફળતાપૂર્વક સબમિટ થયા બાદ, નીચે દર્શાવેલ આવશ્યક દસ્તાવેજોની સ્વપ્રમાણિત નકલ (Self-Attested Copies) PMC ના સરનામે મોકલવાની રહેશે:
    </div>
    <ul style="margin:8px 0 0 18px;padding:0;">
      <li>Registration Certificate</li>
      <li>છેલ્લા 3 વર્ષના Audited Balance Sheet તથા Audit Report</li>
      <li>Registered Rent/Lease Agreement અથવા પોતાની જમીન હોય તો 7/12 તથા 8-A ઉતારા</li>
      <li>Board of Directors / Managing Committee Members List</li>
      <li>Board Resolution (યોજનામાં અરજી કરવા અંગે)</li>
      <li>PAN Card</li>
      <li>GST Registration Number / Certificate (લાગુ પડતું હોય તો)</li>
    </ul>
    <div style="margin-top:8px;font-size:12.5px;color:#374151;">
      <b>નોંધ:</b> દસ્તાવેજો અધૂરા અથવા અસ્પષ્ટ હોવાના કારણે અરજી પ્રક્રિયામાં વિલંબ થવાની શક્યતા રહેશે.
    </div>
  </div>

  <div style="margin-top:14px;">
    <div style="font-weight:800;">મહત્વપૂર્ણ સ્પષ્ટતા:</div>
    <ul style="margin:8px 0 0 18px;padding:0;">
      <li>આ પત્ર માત્ર માહિતી/આમંત્રણ તથા તૈયારી દર્શાવવાનો અધિકૃત પત્ર છે.</li>
      <li>DCDC તથા સંબંધિત સરકારી સત્તાધિકારીઓની અંતિમ મંજૂરી બાદ જ યોજના અમલમાં આવશે.</li>
      <li>આ પત્ર દ્વારા કોઈ પણ નાણાકીય/કાનૂની અધિકાર આપોઆપ પ્રાપ્ત થતો નથી.</li>
      <li>અરજી પ્રક્રિયા ઓનલાઇન પોર્ટલ મારફતે જ માન્ય રહેશે.</li>
    </ul>
  </div>

  <div style="margin-top:16px;">
    <b>આપનો વિશ્વાસુ,</b><br/>
    <b>ગુજરાત સ્ટેટ કો-ઓપરેટિવ માર્કેટિંગ ફેડરેશન લિમિટેડ (GUJCOMASOL)</b><br/>
    Shri Vishwanath Patel Sahakari Bhavan, Plot No. A/5, ADCB Industrial Estate,<br/>
    Sector-25, Gandhinagar – 382025, Gujarat<br/>
    <b>E-mail:</b> info@gujcomasol.com
  </div>

  <div style="margin-top:14px;font-size:12.5px;color:#111827;">
    <b>નકલ રવાના:</b><br/>
    (1) PMC – Shine Agri Allied &amp; Marketing MSCS Ltd.<br/>
    (2) સંબંધિત PACS ના રેકોર્ડ માટે
  </div>
</div>
`;

function buildFinalLetterEmailHTML(r) {
  const nowD = new Date();
  const dd = String(nowD.getDate()).padStart(2, "0");
  const mm = String(nowD.getMonth() + 1).padStart(2, "0");
  const yyyy = nowD.getFullYear();
  const today = `${dd}/${mm}/${yyyy}`;

  const code = safeText(r?.uniqueCode || "");
  const letterNo = `OUT/${yyyy}/${code}`;

  const locationLine = [
    r?.village ? `મુ. ${r.village}` : "",
    r?.taluka ? `તા. ${r.taluka}` : "",
    r?.district ? `જી. ${r.district}` : "",
  ].filter(Boolean).join(", ");

  return FINAL_LETTER_EMAIL_HTML
    .replaceAll("{{LETTER_NO}}", letterNo)
    .replaceAll("{{DATE}}", today)
    .replaceAll("{{INVITATION_CODE}}", safeText(code))
    .replaceAll("{{SOCIETY_NAME}}", safeText(r?.societyName || ""))
    .replaceAll("{{LOCATION_LINE}}", safeText(locationLine || ""));
}
/* ================== FIX END: FINAL LETTER EMAIL TEMPLATE ================== */

function parseCSV(text) {
  const rows = [];
  let i = 0,
    field = "",
    row = [],
    inQuotes = false;

  const pushField = () => {
    row.push(field.trim());
    field = "";
  };
  const pushRow = () => {
    if (row.some((c) => String(c || "").trim() !== "")) rows.push(row);
    row = [];
  };

  while (i < text.length) {
    const ch = text[i];

    if (ch === '"') {
      if (inQuotes && text[i + 1] === '"') {
        field += '"';
        i += 2;
        continue;
      }
      inQuotes = !inQuotes;
      i++;
      continue;
    }
    if (!inQuotes && ch === ",") {
      pushField();
      i++;
      continue;
    }
    if (!inQuotes && (ch === "\n" || ch === "\r")) {
      if (ch === "\r" && text[i + 1] === "\n") i++;
      pushField();
      pushRow();
      i++;
      continue;
    }
    field += ch;
    i++;
  }
  pushField();
  pushRow();
  return rows;
}

async function getNextRecipientCodeBatch(n) {
  const seriesRef = doc(db, "series", "outreach_recipients");

  const { startSeq } = await runTransaction(db, async (tx) => {
    const snap = await tx.get(seriesRef);
    let current = 0;
    if (snap.exists()) current = Number(snap.data().seq || 0);
    tx.set(
      seriesRef,
      { seq: current + n, updatedAt: serverTimestamp() },
      { merge: true }
    );
    return { startSeq: current + 1 };
  });

  return Array.from(
    { length: n },
    (_, k) => `GJCS-${String(startSeq + k).padStart(6, "0")}`
  );
}

/** ========= IMPORTANT: jsPDF Gujarati Font Safe Setup (Fix Unicode error) ========= */
function ensureGujaratiFont(pdf) {
  try {
    const list = pdf.getFontList?.() || {};
    const has = !!list["NotoSansGujarati"];
    if (!has) {
      if (!NOTO_GUJARATI_BASE64 || String(NOTO_GUJARATI_BASE64).length < 1000) {
        return { ok: false, reason: "font_base64_missing" };
      }
      pdf.addFileToVFS("NotoSansGujarati-Regular.ttf", NOTO_GUJARATI_BASE64);
      pdf.addFont(
        "NotoSansGujarati-Regular.ttf",
        "NotoSansGujarati",
        "normal"
      );
    }
    pdf.setFont("NotoSansGujarati", "normal");
    return { ok: true };
  } catch (e) {
    return { ok: false, reason: "font_register_failed" };
  }
}

function safeText(v) {
  return String(v ?? "").replace(/\u0000/g, "").trim();
}

/** Gujarati letter PDF generator (single page) */
function makeGujaratiLetterPDF(rec) {
  const pdf = new jsPDF({ unit: "pt", format: "a4" });

  const fontOk = ensureGujaratiFont(pdf);
  if (!fontOk.ok) {
    pdf.setFont("helvetica", "normal");
  }

  const w = pdf.internal.pageSize.getWidth();
  const h = pdf.internal.pageSize.getHeight();
  const margin = 55;
  const contentW = w - margin * 2;
  let y = 60;

  pdf.setTextColor(0, 0, 0);

  const writeParagraph = (text, fontSize = 11, lineHeight = 14) => {
    pdf.setFontSize(fontSize);
    const lines = pdf.splitTextToSize(safeText(text), contentW);

    for (const line of lines) {
      if (y > h - 70) {
        pdf.addPage();
        ensureGujaratiFont(pdf);
        y = 70;
      }
      pdf.text(safeText(line), margin, y);
      y += lineHeight;
    }
    return lines.length;
  };

  const writeHeading = (label) => {
    if (y > h - 90) {
      pdf.addPage();
      ensureGujaratiFont(pdf);
      y = 70;
    }
    pdf.setFontSize(12);
    pdf.text(safeText(label), margin, y);
    y += 10;
    pdf.setDrawColor(0, 0, 0);
    pdf.setLineWidth(0.6);
    pdf.line(margin, y, w - margin, y);
    y += 16;
  };

  const bullet = (text) => {
    const bulletIndent = 16;
    const lines = pdf.splitTextToSize(safeText(text), contentW - bulletIndent);
    for (let i = 0; i < lines.length; i++) {
      if (y > h - 70) {
        pdf.addPage();
        ensureGujaratiFont(pdf);
        y = 70;
      }
      pdf.setFontSize(11);
      if (i === 0) pdf.text("•", margin, y);
      pdf.text(safeText(lines[i]), margin + bulletIndent, y);
      y += 14;
    }
  };

  // ===== TOP HEADER BOX =====
  pdf.setDrawColor(180, 180, 180);
  pdf.setLineWidth(0.8);
  pdf.roundedRect(margin - 6, y - 12, contentW + 12, 80, 10, 10);

  pdf.setFontSize(15);
  pdf.text("GUJCOMASOL", margin, y + 10);

  pdf.setFontSize(10);
  pdf.setTextColor(60, 60, 60);
  pdf.text(
    "World’s Largest Grain Storage Plan in Cooperative Sector",
    margin,
    y + 28
  );

  pdf.setTextColor(0, 0, 0);
  pdf.setFontSize(10);
  pdf.text(
    `આમંત્રણ કોડ (Invitation Code): ${safeText(rec.uniqueCode || "—")}`,
    margin,
    y + 46
  );

  y += 95;

  // ===== LETTER META =====
  pdf.setFontSize(11);
  pdf.text("પત્ર ક્રમાંક : ____________", margin, y);
  y += 16;
  pdf.text("તારીખ : ___ / ___ / 2025", margin, y);
  y += 22;

  // ===== ADDRESS =====
  pdf.setFontSize(12);
  pdf.text("પ્રતિ,", margin, y);
  y += 18;

  writeParagraph(safeText(rec.societyName || ""), 11, 14);

  if (safeText(rec.address)) writeParagraph(safeText(rec.address), 11, 14);

  const locParts = [];
  if (safeText(rec.village)) locParts.push(`મુ. ${safeText(rec.village)}`);
  if (safeText(rec.taluka)) locParts.push(`તા. ${safeText(rec.taluka)}`);
  if (safeText(rec.district)) locParts.push(`જી. ${safeText(rec.district)}`);
  if (locParts.length) writeParagraph(locParts.join(", "), 11, 14);

  y += 10;

  const subjectText =
    "વિષય : ભારત સરકારના સહકાર મંત્રાલય દ્વારા અમલમાં મુકાયેલ “World’s Largest Grain Storage Plan in Cooperative Sector” " +
    "યોજનાઅંતર્ગત PACS/સહકારી સંસ્થાઓ દ્વારા અનાજ સંગ્રહ ગોડાઉન નિર્માણ માટે ઓનલાઈન અરજી કરવા બાબત.";

  writeHeading("વિષય");
  writeParagraph(subjectText, 11, 14);
  y += 6;

  writeParagraph("મહાશય,", 11, 14);
  y += 6;

  const para1 =
    "ભારત સરકારના સહકાર મંત્રાલય દ્વારા સહકારી ક્ષેત્રમાં અનાજ સંગ્રહ ક્ષમતા વધારવા માટે અમલમાં મુકાયેલ " +
    "“World’s Largest Grain Storage Plan in Cooperative Sector” યોજના અંતર્ગત પાત્ર સહકારી સંસ્થાઓ/પ્રાથમિક કૃષિ સહકારી મંડળીઓ (PACS) " +
    "દ્વારા ગોડાઉન/સંગ્રહ ઇન્ફ્રાસ્ટ્રક્ચર બનાવવાની સુવિધા ઉપલબ્ધ કરાવવામાં આવી છે.";
  writeParagraph(para1, 11, 14);
  y += 10;

  const para2 =
    "આ યોજનાની માર્ગદર્શિકા (Margdarshika) મુજબ પાત્ર સંસ્થાઓ દ્વારા 500 MT / 1000 MT અથવા તેથી વધુ ક્ષમતાના " +
    "આધુનિક અનાજ સંગ્રહ ગોડાઉન માટે અરજી કરી શકાય છે. પ્રોજેક્ટ મંજૂરી, Hiring Assurance, બેંક ફાઇનાન્સ અને સબસિડી સંબંધિત પ્રક્રિયા " +
    "સંબંધીત DCDC/સક્ષમ અધિકારીઓ દ્વારા લાગુ નિયમો મુજબ કરવામાં આવશે.";
  writeParagraph(para2, 11, 14);
  y += 10;

  writeHeading("યોજનાની મુખ્ય શરતો (Margdarshika મુજબ)");
  bullet("500 MT / 1000 MT અથવા તેથી વધુ ક્ષમતાનો અનાજ સંગ્રહ ગોડાઉન.");
  bullet(
    "જમીન પોતાની હોય તો/અથવા DCDC મંજૂરી બાદ ઓછામાં ઓછા 20 (વીસ) વર્ષ માટે કાયદેસર લીઝ પર જમીન મેળવવા તૈયાર."
  );
  bullet("DCDC મંજૂરી, Hiring Assurance, બેંક ફાઇનાન્સ તથા સબસિડી આધારિત સમયબદ્ધ અમલ.");
  bullet("WDRA તથા અન્ય લાગુ સરકારી નિયમો/ગુણવત્તા ધોરણોનું પાલન.");

  y += 8;

  writeHeading("અરજી કરવાની પદ્ધતિ (IMPORTANT)");
  writeParagraph(
    "યોજનાની માર્ગદર્શિકા મુજબ અરજી ઓનલાઈન પોર્ટલ મારફતે જ કરવાની રહેશે. નીચેની લિંક દ્વારા અરજી કરી શકો છો:",
    11,
    14
  );

  if (y > h - 70) {
    pdf.addPage();
    ensureGujaratiFont(pdf);
    y = 70;
  }
  pdf.setFontSize(11);
  pdf.setTextColor(0, 102, 204);
  pdf.text("https://www.shineagri.org/apply-godown", margin, y);
  pdf.setTextColor(0, 0, 0);
  y += 18;

  writeParagraph(
    `આપનો આમંત્રણ કોડ (Invitation Code): ${safeText(rec.uniqueCode || "—")}`,
    11,
    14
  );
  y += 10;

  writeHeading("પ્રક્રિયા, માર્ગદર્શન અને હેન્ડહોલ્ડિંગ અંગે");
  writeParagraph(
    "આ યોજનાની અરજી પ્રક્રિયા, દસ્તાવેજીકરણ, DPR તૈયારી, સાઇટ વિઝિટ, DCDC સંકલન તથા અમલીકરણ દરમ્યાન માર્ગદર્શન/હેન્ડહોલ્ડિંગ માટે " +
      "Project Management Consultant (PMC) તરીકે નીચે મુજબ સહાય ઉપલબ્ધ રહેશે:",
    11,
    14
  );

  [
    "Project Management Consultant (PMC):",
    "Shine Agri Allied & Marketing Multistate Cooperative Society Limited",
    "Coordination Partner: GUJCOMASOL",
  ].forEach((line) => bullet(line));

  y += 10;

  writeHeading("મહત્વપૂર્ણ સ્પષ્ટતા");
  bullet("આ પત્ર માત્ર માહિતી/આમંત્રણ તથા તૈયારી દર્શાવવાનો અધિકૃત પત્ર છે.");
  bullet("DCDC તથા સંબંધિત સરકારી સત્તાધિકારીઓની અંતિમ મંજૂરી બાદ જ યોજના અમલમાં આવશે.");
  bullet("આ પત્ર દ્વારા કોઈ પણ નાણાકીય/કાનૂની અધિકાર આપોઆપ પ્રાપ્ત થતો નથી.");
  bullet("અરજી પ્રક્રિયા ઓનલાઇન પોર્ટલ મારફતે જ માન્ય રહેશે.");

  y += 10;

  if (y > h - 140) {
    pdf.addPage();
    ensureGujaratiFont(pdf);
    y = 70;
  }

  pdf.setFontSize(11);
  pdf.text("આપનો વિશ્વાસુ,", margin, y);
  y += 26;

  pdf.text("GUJCOMASOL તરફથી", margin, y);
  y += 18;

  pdf.text("(અધિકૃત સહી)", margin, y);
  y += 18;

  pdf.text("નામ : ____________________________", margin, y);
  y += 16;
  pdf.text("હોદ્દો : __________________________", margin, y);
  y += 16;
  pdf.text("સીલ : _____________________________", margin, y);

  pdf.setFontSize(9);
  pdf.setTextColor(120, 120, 120);
  pdf.text(
    "Note: આ દસ્તાવેજ સિસ્ટમ જનરેટેડ છે. અંતિમ પ્રક્રિયા/મંજૂરી લાગુ માર્ગદર્શિકા મુજબ થશે.",
    margin,
    h - 30
  );

  return pdf.output("blob");
}

function downloadCSV(filename, rows) {
  const escape = (v) => {
    const s = String(v ?? "");
    if (s.includes(",") || s.includes('"') || s.includes("\n")) {
      return `"${s.replaceAll('"', '""')}"`;
    }
    return s;
  };
  const csv = rows.map((r) => r.map(escape).join(",")).join("\n");
  const blob = new Blob([csv], { type: "text/csv;charset=utf-8" });
  saveAs(blob, filename);
}

/** ========== Delete helper (handles >500 docs safely) ========== */
async function deleteRecipientsByBatchId(batchId) {
  const colRef = collection(db, "outreach_recipients");
  let loop = 0;

  while (true) {
    loop++;
    const q = query(colRef, where("sourceBatchId", "==", batchId), limit(450));
    const snap = await getDocs(q);
    if (snap.empty) break;

    const batch = writeBatch(db);
    snap.docs.forEach((d) => batch.delete(d.ref));
    await batch.commit();

    if (loop > 60) break;
  }
}

/* =========================================================
   ✅ NEW: Canvas-based Gujarati PDF (NO html2canvas needed)
   - Gujarati text perfect
   - No GUJCOMASOL header (for letterhead printing)
   ========================================================= */

let __gujFontReadyPromise = null;

function base64ToArrayBuffer(base64) {
  const bin = atob(base64);
  const len = bin.length;
  const bytes = new Uint8Array(len);
  for (let i = 0; i < len; i++) bytes[i] = bin.charCodeAt(i);
  return bytes.buffer;
}

function ensureCanvasGujaratiFont() {
  if (__gujFontReadyPromise) return __gujFontReadyPromise;

  __gujFontReadyPromise = (async () => {
    try {
      const buf = base64ToArrayBuffer(String(NOTO_GUJARATI_BASE64 || ""));
      const font = new FontFace("NotoSansGujaratiCanvas", buf);
      await font.load();
      document.fonts.add(font);
      await document.fonts.ready;
      return true;
    } catch (e) {
      return false;
    }
  })();

  return __gujFontReadyPromise;
}

function wrapTextCanvas(ctx, text, maxWidth) {
  const words = String(text || "").split(/\s+/);
  const lines = [];
  let line = "";

  for (const w of words) {
    const test = line ? `${line} ${w}` : w;
    if (ctx.measureText(test).width <= maxWidth) {
      line = test;
    } else {
      if (line) lines.push(line);
      line = w;
    }
  }
  if (line) lines.push(line);
  return lines;
}

async function makeGujaratiLetterPDF_Canvas(rec) {
  await ensureCanvasGujaratiFont();

  const pdf = new jsPDF({ unit: "pt", format: "a4" });
  const pageW = pdf.internal.pageSize.getWidth();
  const pageH = pdf.internal.pageSize.getHeight();

  // Quality
  const scale = 2;
  const cW = Math.floor(pageW * scale);
  const cH = Math.floor(pageH * scale);

  // Margins (professional)
  const marginPt = 58;
  const left = marginPt * scale;
  const right = (pageW - marginPt) * scale;
  const maxTextW = right - left;

  // ✅ Letterhead printing space (top)
  const topLetterheadSpace = 150; // pt (adjust if needed)
  const topSpacePx = topLetterheadSpace * scale;

  // Fonts
  const fontStack =
    `"Shruti","Nirmala UI","Gujarati Sangam MN","Noto Sans Gujarati","NotoSansGujaratiCanvas",Arial,sans-serif`;

  const szBody = 13 * scale;      // govt body
  const szSmall = 12 * scale;     // meta/footer
  const szHeading = 13.5 * scale; // heading label
  const lineH = 16.5 * scale;     // tighter, clean

  const pad2 = (n) => String(n).padStart(2, "0");
  const now = new Date();
  const dd = pad2(now.getDate());
  const mm = pad2(now.getMonth() + 1);
  const yyyy = now.getFullYear();
  const today = `${dd}/${mm}/${yyyy}`;

  const code = safeText(rec?.uniqueCode || "—");
  const letterNo = `OUT/${yyyy}/${code}`;

  // ✅ PMC CONTACT DETAILS (FINAL)
  const PMC_NAME = "Shine Agri Allied & Marketing Multistate Cooperative Society Limited";
  const PMC_ADDRESS =
    "48, 1st Amar Arcade, Nilpur, Taluka–Dantiwada, District Banaskantha, Gujarat – 385505, India";
  const PMC_EMAIL = "tender@shineagri.org";
  const PMC_PHONE = "9274799225 / 761869225";

  const newCanvas = () => {
    const canvas = document.createElement("canvas");
    canvas.width = cW;
    canvas.height = cH;
    const ctx = canvas.getContext("2d");
    ctx.fillStyle = "#ffffff";
    ctx.fillRect(0, 0, cW, cH);
    ctx.fillStyle = "#111111";
    ctx.textBaseline = "top";
    return { canvas, ctx };
  };

  let { canvas, ctx } = newCanvas();
  let y = topSpacePx;

  const flushPageToPDF = () => {
    const img = canvas.toDataURL("image/png");
    pdf.addImage(img, "PNG", 0, 0, pageW, pageH);
  };

  const nextPage = () => {
    flushPageToPDF();
    pdf.addPage();
    const x = newCanvas();
    canvas = x.canvas;
    ctx = x.ctx;
    y = topSpacePx;
  };

  const setFont = (sizePx, weight = "normal") => {
    ctx.font = `${weight} ${sizePx}px ${fontStack}`;
  };

  const wrapTextCanvas = (text, maxWidthPx) => {
    const words = String(text || "").split(/\s+/);
    const lines = [];
    let line = "";
    for (const w of words) {
      const test = line ? `${line} ${w}` : w;
      if (ctx.measureText(test).width <= maxWidthPx) line = test;
      else {
        if (line) lines.push(line);
        line = w;
      }
    }
    if (line) lines.push(line);
    return lines;
  };

  const drawPara = (text, size = szBody, weight = "normal") => {
    setFont(size, weight);
    const lines = wrapTextCanvas(safeText(text), maxTextW);
    for (const ln of lines) {
      if (y + lineH > cH - 90 * scale) nextPage();
      ctx.fillText(ln, left, y);
      y += lineH;
    }
  };

  const drawGap = (pt) => {
    y += pt * scale;
  };

  const drawRule = (thickness = 1.2) => {
    if (y + 10 * scale > cH - 90 * scale) nextPage();
    ctx.strokeStyle = "#111111";
    ctx.lineWidth = thickness * scale;
    ctx.beginPath();
    ctx.moveTo(left, y);
    ctx.lineTo(right, y);
    ctx.stroke();
    y += 10 * scale;
  };

  const drawHeadingLabel = (label) => {
    setFont(szHeading, "700");
    if (y + lineH > cH - 90 * scale) nextPage();
    ctx.fillText(label, left, y);
    y += lineH * 0.85;
    drawRule(0.9);
  };

  const drawBullet = (text) => {
    setFont(szBody, "normal");
    const bulletX = left;
    const textX = left + 18 * scale;
    const lines = wrapTextCanvas(safeText(text), maxTextW - 18 * scale);
    for (let i = 0; i < lines.length; i++) {
      if (y + lineH > cH - 90 * scale) nextPage();
      if (i === 0) ctx.fillText("•", bulletX, y);
      ctx.fillText(lines[i], textX, y);
      y += lineH;
    }
  };

  // ================== CONTENT (Govt draft style) ==================

  // Meta row
  setFont(szSmall, "700");
  if (y + lineH > cH - 90 * scale) nextPage();
  ctx.fillText(`પત્ર ક્રમાંક: ${letterNo}`, left, y);

  const dateText = `તારીખ: ${today}`;
  const dateW = ctx.measureText(dateText).width;
  ctx.fillText(dateText, right - dateW, y);
  y += lineH;

  drawGap(10);

  // Address block
  drawPara("પ્રતિ,", szBody, "700");
  drawGap(2);

  drawPara("માનનીય ચેરમેનશ્રી / સેક્રેટરીશ્રી / મેનેજરશ્રી,", szBody, "700");
  drawPara(safeText(rec?.societyName || ""), szBody, "700");

  const locParts = [];
  if (safeText(rec?.village)) locParts.push(`મુ. ${safeText(rec.village)}`);
  if (safeText(rec?.taluka)) locParts.push(`તા. ${safeText(rec.taluka)}`);
  if (safeText(rec?.district)) locParts.push(`જી. ${safeText(rec.district)}`);
  if (locParts.length) drawPara(locParts.join(", "), szBody, "normal");

  drawGap(12);

  // Subject
  drawHeadingLabel("વિષય:");
  drawPara(
    "ભારત સરકારના સહકાર મંત્રાલય દ્વારા અમલમાં મુકાયેલ “World’s Largest Grain Storage Plan in Cooperative Sector” યોજનાઅંતર્ગત " +
      "PACS/સહકારી સંસ્થાઓ દ્વારા અનાજ સંગ્રહ ગોડાઉન નિર્માણ માટે ઓનલાઈન અરજી કરવા બાબત.",
    szBody,
    "normal"
  );

  drawGap(12);

  // Greeting
  drawPara("ઉપરોક્ત વિષય સંદર્ભે આપને જાણ કરવામાં આવે છે કે,", szBody, "normal");
  drawGap(6);

  // Body
  drawPara(
    "ભારત સરકારના સહકાર મંત્રાલય દ્વારા સહકારી ક્ષેત્રમાં અનાજ સંગ્રહ ક્ષમતા વધારવા માટે અમલમાં મુકાયેલ “World’s Largest Grain Storage Plan in Cooperative Sector” " +
      "યોજનાઅંતર્ગત પાત્ર સહકારી સંસ્થાઓ/પ્રાથમિક કૃષિ સહકારી મંડળીઓ (PACS) દ્વારા ગોડાઉન/સંગ્રહ ઈન્ફ્રાસ્ટ્રક્ચર બનાવવાની સુવિધા ઉપલબ્ધ કરાવવામાં આવી છે.",
    szBody,
    "normal"
  );

  drawGap(6);

  drawPara(
    "આ યોજનાની માર્ગદર્શિકા (Margdarshika) મુજબ પાત્ર સંસ્થાઓ દ્વારા 500 MT / 1000 MT અથવા તેથી વધુ ક્ષમતાના આધુનિક અનાજ સંગ્રહ ગોડાઉન માટે અરજી કરી શકાય છે. " +
      "પ્રોજેક્ટ મંજૂરી, Hiring Assurance, બેંક ફાઇનાન્સ તથા સબસિડી સંબંધિત પ્રક્રિયા સંબંધિત DCDC/સક્ષમ અધિકારીઓ દ્વારા લાગુ નિયમો મુજબ કરવામાં આવશે.",
    szBody,
    "normal"
  );

  // Conditions
  drawGap(10);
  drawHeadingLabel("યોજનાની મુખ્ય શરતો (Margdarshika મુજબ):");
  drawBullet("500 MT / 1000 MT અથવા તેથી વધુ ક્ષમતાનો અનાજ સંગ્રહ ગોડાઉન.");
  drawBullet("જમીન પોતાની હોય તો/અથવા DCDC મંજૂરી બાદ ઓછામાં ઓછા 20 (વીસ) વર્ષ માટે કાયદેસર લીઝ પર જમીન મેળવવા તૈયાર.");
  drawBullet("DCDC મંજૂરી, Hiring Assurance, બેંક ફાઇનાન્સ તથા સબસિડી આધારિત સમયબદ્ધ અમલ.");
  drawBullet("WDRA તથા અન્ય લાગુ સરકારી નિયમો/ગુણવત્તા ધોરણોનું પાલન.");

  // Apply section
  drawGap(10);
  drawHeadingLabel("અરજી કરવાની પદ્ધતિ (IMPORTANT):");
  drawPara(
    "યોજનાની માર્ગદર્શિકા મુજબ અરજી ઓનલાઈન પોર્ટલ મારફતે જ કરવાની રહેશે. નીચેની લિંક દ્વારા અરજી કરી શકો છો:",
    szBody,
    "normal"
  );

  // Link (blue) + underline
  setFont(szBody, "700");
  ctx.fillStyle = "#0b63ce";
  if (y + lineH > cH - 90 * scale) nextPage();
  ctx.fillText("https://www.shineagri.org/apply-godown", left, y);
  ctx.fillStyle = "#111111";
  y += lineH;
  drawRule(0.9);

  drawGap(2);
  drawPara(`આપનો આમંત્રણ કોડ (Invitation Code): ${code}`, szBody, "700");

  // PMC section
  drawGap(10);
  drawHeadingLabel("પ્રક્રિયા માર્ગદર્શન (PMC સપોર્ટ):");

  drawPara(
    "યોજનાની અરજી પ્રક્રિયા, દસ્તાવેજીકરણ, DPR તૈયારી, સાઇટ વિઝિટ, DCDC સંકલન તથા અમલીકરણ દરમ્યાન જરૂરી માર્ગદર્શન/હેન્ડહોલ્ડિંગ માટે " +
      "Project Management Consultant (PMC) તરીકે નીચે મુજબ સહાય ઉપલબ્ધ રહેશે:",
    szBody,
    "normal"
  );

  drawGap(4);
  drawBullet("દસ્તાવેજ ચકાસણી તથા ઓનલાઈન અરજીમાં સહાય.");
  drawBullet("DPR/Project Report તૈયાર કરાવવાની પ્રક્રિયામાં માર્ગદર્શન.");
  drawBullet("Site Visit & Technical Coordination (જરૂર મુજબ).");
  drawBullet("DCDC/સંબંધિત સત્તાધિકારીઓ સાથે સમન્વય અને માર્ગદર્શન.");
  drawBullet("યોજના મુજબ સમયબદ્ધ અમલ માટે જરૂરી માર્ગદર્શન.");

  drawGap(6);
  drawPara("PMC / Coordination Details:", szBody, "700");
  drawBullet("Coordination Partner: GUJCOMASOL");

  // ✅ Document submission + checklist
  drawGap(12);
  drawHeadingLabel("અરજી બાદ દસ્તાવેજ મોકલવા અંગે (Document Submission – PMC):");

  drawPara(
    "ઓનલાઈન અરજી સફળતાપૂર્વક સબમિટ થયા બાદ, નીચે દર્શાવેલ આવશ્યક દસ્તાવેજોની સ્વપ્રમાણિત નકલ (Self-Attested Copies) " +
      "Project Management Consultant (PMC) ના સરનામે મોકલવાની રહેશે. દસ્તાવેજોની ચકાસણી તથા આગળની પ્રક્રિયા " +
      "આ દસ્તાવેજોના આધારે કરવામાં આવશે.",
    szBody,
    "normal"
  );

  drawGap(4);
  drawBullet("સંસ્થાનું Registration Certificate.");
  drawBullet("છેલ્લા 3 વર્ષના Audited Balance Sheet તથા Audit Report.");
  drawBullet("જમીનના દસ્તાવેજો: ભાડે જમીન હોય તો Registered Rent/Lease Agreement, અથવા પોતાની જમીન હોય તો 7/12 તથા 8-A ઉતારા.");
  drawBullet("Board of Directors / Managing Committee Members List.");
  drawBullet("યોજનામાં અરજી કરવા અંગેનું Board Resolution.");
  drawBullet("સંસ્થાનું PAN Card.");
  drawBullet("GST Registration Certificate / Number (લાગુ પડતું હોય તો).");

  drawGap(6);
  drawPara("દસ્તાવેજો મોકલવાનું સરનામું (PMC Address):", szBody, "700");
  drawBullet(PMC_NAME);
  drawBullet(PMC_ADDRESS);
  drawBullet(`Email: ${PMC_EMAIL}`);
  drawBullet(`Helpline: ${PMC_PHONE}`);
  drawBullet(`Helpline: ${PMC_PHONE}`);

  drawGap(6);
  drawPara(
    "નોંધ: દસ્તાવેજો અધૂરા અથવા અસ્પષ્ટ હોવાના કારણે અરજી પ્રક્રિયામાં વિલંબ થવાની શક્યતા રહેશે.",
    szSmall,
    "normal"
  );

  // Clarification
  drawGap(10);
  drawHeadingLabel("મહત્વપૂર્ણ સ્પષ્ટતા:");
  drawBullet("આ પત્ર માત્ર માહિતી/આમંત્રણ તથા તૈયારી દર્શાવવાનો અધિકૃત પત્ર છે.");
  drawBullet("DCDC તથા સંબંધિત સરકારી સત્તાધિકારીઓની અંતિમ મંજૂરી બાદ જ યોજના અમલમાં આવશે.");
  drawBullet("આ પત્ર દ્વારા કોઈ પણ નાણાકીય/કાનૂની અધિકાર આપોઆપ પ્રાપ્ત થતો નથી.");
  drawBullet("અરજી પ્રક્રિયા ઓનલાઇન પોર્ટલ મારફતે જ માન્ય રહેશે.");

  // Signature block
  drawGap(12);
  drawPara("આપનો વિશ્વાસુ,", szBody, "normal");
  drawGap(10);
  drawGap(6);
  drawPara("ગુજરાત સ્ટેટ કો-ઓપરેટિવ માર્કેટિંગ ફેડરેશન લિમિટેડ", szBody, "700");
  drawPara("(ગુજકોમાસોલ)", szBody, "700");

  drawGap(6);
  drawPara("સરનામું:", szBody, "700");
  drawPara(
    "શ્રી વિશ્વનાથ પટેલ સહકારી ભવન, પ્લોટ નં. A/5, એ.ડી.સી.બી. ઈન્ડસ્ટ્રિયલ એસ્ટેટ, સેક્ટર–25, ગાંધીનગર – 382025, ગુજરાત.",
    szBody,
    "normal"
  );

  drawGap(12);
  drawPara("નકલ રવાના:", szBody, "700");

  drawPara(
    "(1) Project Management Consultant (PMC) – Shine Agri Allied & Marketing Multistate Cooperative Society Limited.",
    szBody,
    "normal"
  );
  drawPara("(2) સંબંધિત PACS ના રેકોર્ડ માટે.", szBody, "normal");

  // Footer
  setFont(11 * scale, "normal");
  const footer = `Ref: ${letterNo}  |  Date: ${today}`;
  const fw = ctx.measureText(footer).width;
  ctx.fillStyle = "#666";
  ctx.fillText(footer, right - fw, cH - 40 * scale);

  // finalize
  flushPageToPDF();
  return pdf.output("blob");
}

export default function OutreachDashboard() {
  const [rows, setRows] = useState([]);
  const [unmatched, setUnmatched] = useState([]);
  const [loading, setLoading] = useState(true);

  const [search, setSearch] = useState("");
  const [statusFilter, setStatusFilter] = useState("ALL");

  const [selected, setSelected] = useState({});

  const [batches, setBatches] = useState([]);
  const [activeBatchId, setActiveBatchId] = useState("");

  const [editOpen, setEditOpen] = useState(false);
  const [editRow, setEditRow] = useState(null);

  /* ================== FIX START: SERVER-SIDE PAGINATION STATE ================== */
  const [pageSize, setPageSize] = useState(10);
  const [page, setPage] = useState(1);
  const [totalCount, setTotalCount] = useState(0);
  const [pageCount, setPageCount] = useState(1);
  const [pageLastDocs, setPageLastDocs] = useState([]); // stores lastDoc for each page (index: page-1)
  const [pageLoading, setPageLoading] = useState(false);
  /* ================== FIX END: SERVER-SIDE PAGINATION STATE ================== */

  /* ================== FIX START: REAL STATS STATE (NO MORE 0) ================== */
  const [statsCounts, setStatsCounts] = useState({
    total: 0,
    applied: 0,
    pending: 0,
    emailQueuedOrSent: 0,
    courierSent: 0,
    unmatched: 0,
  });
  /* ================== FIX END: REAL STATS STATE (NO MORE 0) ================== */

  useEffect(() => {
    /* ================== FIX START: DISABLE FULL DATA REALTIME LOAD (KEEP ORIGINAL LINES) ================== */
    if (false) {
      const q1 = query(collection(db, "outreach_recipients"), orderBy("createdAt", "desc"));
      const unsub1 = onSnapshot(
        q1,
        (snap) => {
          setRows(snap.docs.map((d) => ({ id: d.id, ...d.data() })));
          setLoading(false);
        },
        (err) => {
          console.error("outreach_recipients snapshot error:", err);
          setLoading(false);
          toast.error(err?.code ? `Firestore: ${err.code}` : "Firestore read failed");
        }
      );
      return () => { unsub1(); };
    }
    /* ================== FIX END: DISABLE FULL DATA REALTIME LOAD (KEEP ORIGINAL LINES) ================== */

    const q2 = query(collection(db, "unmatched_applications"), orderBy("createdAt", "desc"));
    const unsub2 = onSnapshot(q2, (snap) => {
      setUnmatched(snap.docs.map((d) => ({ id: d.id, ...d.data() })));
    });

    const q3 = query(collection(db, "outreach_import_batches"), orderBy("createdAt", "desc"));
    const unsub3 = onSnapshot(q3, (snap) => {
      setBatches(snap.docs.map((d) => ({ id: d.id, ...d.data() })));
    });

    const unsub4 = onSnapshot(doc(db, "series", "outreach_active_csv"), (snap) => {
      const v = snap.exists() ? snap.data() : {};
      setActiveBatchId(v?.activeBatchId || "");
    });

    return () => { unsub2(); unsub3(); unsub4(); };
  }, []);

  /* ================== FIX START: SERVER-SIDE PAGINATION QUERY BUILDER ================== */
  function buildRecipientsBaseQuery() {
    // ✅ NOTE: Search is client-side on current page (Firestore "contains" not possible without search index field).
    // ✅ Status filter is server-side.
    // ✅ ACTIVE BATCH filter is server-side (so only current dataset shows)
    let qx = query(
      collection(db, "outreach_recipients"),
      orderBy("uniqueCode", "asc")
    );

    if (activeBatchId) {
      // keep dataset stable (active CSV only)
      qx = query(
        collection(db, "outreach_recipients"),
        where("sourceBatchId", "==", activeBatchId),
        orderBy("uniqueCode", "asc")
      );
    }

    if (statusFilter !== "ALL") {
      if (activeBatchId) {
        qx = query(
          collection(db, "outreach_recipients"),
          where("sourceBatchId", "==", activeBatchId),
          where("outreachStatus", "==", statusFilter),
          orderBy("uniqueCode", "asc")
        );
      } else {
        qx = query(
          collection(db, "outreach_recipients"),
          where("outreachStatus", "==", statusFilter),
          orderBy("uniqueCode", "asc")
        );
      }
    }

    return qx;
  }

  /* ================== FIX START: REAL STATS COUNTS USING getCountFromServer() ================== */
  function buildStatsBaseQuery() {
    // Stats should be for full ACTIVE dataset, not affected by current status filter/search
    if (activeBatchId) {
      return query(
        collection(db, "outreach_recipients"),
        where("sourceBatchId", "==", activeBatchId)
      );
    }
    return query(collection(db, "outreach_recipients"));
  }

  async function refreshStatsCounts() {
    try {
      const base = buildStatsBaseQuery();

      const totalSnap = await getCountFromServer(base);
      const total = Number(totalSnap.data()?.count || 0);

      const appliedSnap = await getCountFromServer(
        activeBatchId
          ? query(
              collection(db, "outreach_recipients"),
              where("sourceBatchId", "==", activeBatchId),
              where("outreachStatus", "==", "APPLIED")
            )
          : query(
              collection(db, "outreach_recipients"),
              where("outreachStatus", "==", "APPLIED")
            )
      );
      const applied = Number(appliedSnap.data()?.count || 0);

      const emailQueuedSnap = await getCountFromServer(
        activeBatchId
          ? query(
              collection(db, "outreach_recipients"),
              where("sourceBatchId", "==", activeBatchId),
              where("outreachStatus", "==", "EMAIL_QUEUED")
            )
          : query(
              collection(db, "outreach_recipients"),
              where("outreachStatus", "==", "EMAIL_QUEUED")
            )
      );
      const emailSentSnap = await getCountFromServer(
        activeBatchId
          ? query(
              collection(db, "outreach_recipients"),
              where("sourceBatchId", "==", activeBatchId),
              where("outreachStatus", "==", "EMAIL_SENT")
            )
          : query(
              collection(db, "outreach_recipients"),
              where("outreachStatus", "==", "EMAIL_SENT")
            )
      );
      const bothSentSnap = await getCountFromServer(
        activeBatchId
          ? query(
              collection(db, "outreach_recipients"),
              where("sourceBatchId", "==", activeBatchId),
              where("outreachStatus", "==", "BOTH_SENT")
            )
          : query(
              collection(db, "outreach_recipients"),
              where("outreachStatus", "==", "BOTH_SENT")
            )
      );

      const emailQueuedOrSent =
        Number(emailQueuedSnap.data()?.count || 0) +
        Number(emailSentSnap.data()?.count || 0) +
        Number(bothSentSnap.data()?.count || 0);

      const courierSentSnap = await getCountFromServer(
        activeBatchId
          ? query(
              collection(db, "outreach_recipients"),
              where("sourceBatchId", "==", activeBatchId),
              where("outreachStatus", "==", "COURIER_SENT")
            )
          : query(
              collection(db, "outreach_recipients"),
              where("outreachStatus", "==", "COURIER_SENT")
            )
      );
      const courierSent = Number(courierSentSnap.data()?.count || 0) + Number(bothSentSnap.data()?.count || 0);

      const unmatchedSnap = await getCountFromServer(query(collection(db, "unmatched_applications")));
      const unmatchedCount = Number(unmatchedSnap.data()?.count || 0);

      const pending = Math.max(0, total - applied);

      setStatsCounts({
        total,
        applied,
        pending,
        emailQueuedOrSent,
        courierSent,
        unmatched: unmatchedCount,
      });
    } catch (e) {
      console.error("refreshStatsCounts error:", e);
      // do not toast spam on every refresh; keep silent
    }
  }
  /* ================== FIX END: REAL STATS COUNTS USING getCountFromServer() ================== */

  async function refreshCountAndPage1() {
    try {
      setPageLoading(true);
      setLoading(true);

      const baseQ = buildRecipientsBaseQuery();
      const cSnap = await getCountFromServer(baseQ);
      const cnt = Number(cSnap.data()?.count || 0);

      setTotalCount(cnt);
      const pc = Math.max(1, Math.ceil(cnt / pageSize));
      setPageCount(pc);

      // Reset cursors
      setPageLastDocs([]);

      // Fetch first page
      const qFirst = query(baseQ, limit(pageSize));
      const snap = await getDocs(qFirst);

      const docs = snap.docs;
      const items = docs.map((d) => ({ id: d.id, ...d.data() }));
      setRows(items);

      const last = docs.length ? docs[docs.length - 1] : null;
      setPageLastDocs(last ? [last] : []);

      setPage(1);
      setSelected({});
      setLoading(false);
      setPageLoading(false);

      /* ================== FIX START: STATS REFRESH (REAL) ================== */
      refreshStatsCounts();
      /* ================== FIX END: STATS REFRESH (REAL) ================== */
    } catch (e) {
      console.error("pagination count/page1 error:", e);
      setLoading(false);
      setPageLoading(false);
      toast.error(e?.code ? `Firestore: ${e.code}` : "Pagination load failed. Check console.");
    }
  }

  async function fetchPage(targetPage) {
    try {
      const baseQ = buildRecipientsBaseQuery();
      const pc = Math.max(1, Math.ceil((totalCount || 0) / pageSize));
      const safeTarget = Math.min(Math.max(1, targetPage), pc);

      setPageLoading(true);
      setLoading(true);

      if (safeTarget === 1) {
        const qFirst = query(baseQ, limit(pageSize));
        const snap = await getDocs(qFirst);
        const docs = snap.docs;
        setRows(docs.map((d) => ({ id: d.id, ...d.data() })));
        const last = docs.length ? docs[docs.length - 1] : null;
        setPageLastDocs(last ? [last] : []);
        setPage(1);
        setSelected({});
        setLoading(false);
        setPageLoading(false);
        return;
      }

      // Ensure we have cursor for previous page
      const prevIndex = safeTarget - 2; // previous page index
      const prevLastDoc = pageLastDocs[prevIndex];

      if (!prevLastDoc) {
        // If user jumps directly to far page without cursor chain, we rebuild cursors sequentially quickly
        // (still server-side, but steps through pages until target).
        let tempLastDocs = [...pageLastDocs];
        let currentPage = tempLastDocs.length; // last known page count in cursor cache
        let lastDoc = tempLastDocs.length ? tempLastDocs[tempLastDocs.length - 1] : null;

        if (currentPage < 1) {
          // start from page 1
          const snap1 = await getDocs(query(baseQ, limit(pageSize)));
          const docs1 = snap1.docs;
          const last1 = docs1.length ? docs1[docs1.length - 1] : null;
          tempLastDocs = last1 ? [last1] : [];
          currentPage = 1;
          lastDoc = last1;
        }

        while (currentPage < safeTarget - 1) {
          if (!lastDoc) break;
          const sn = await getDocs(query(baseQ, startAfter(lastDoc), limit(pageSize)));
          const ds = sn.docs;
          const l = ds.length ? ds[ds.length - 1] : null;
          tempLastDocs[currentPage] = l;
          currentPage += 1;
          lastDoc = l;
          if (!l) break;
        }

        setPageLastDocs(tempLastDocs);

        const usePrev = tempLastDocs[safeTarget - 2];
        if (!usePrev) {
          setRows([]);
          setPage(safeTarget);
          setSelected({});
          setLoading(false);
          setPageLoading(false);
          return;
        }

        const snapT = await getDocs(query(baseQ, startAfter(usePrev), limit(pageSize)));
        const docsT = snapT.docs;
        setRows(docsT.map((d) => ({ id: d.id, ...d.data() })));

        const lastT = docsT.length ? docsT[docsT.length - 1] : null;
        const nextLastDocs = [...tempLastDocs];
        nextLastDocs[safeTarget - 1] = lastT;
        setPageLastDocs(nextLastDocs);

        setPage(safeTarget);
        setSelected({});
        setLoading(false);
        setPageLoading(false);
        return;
      }

      const qPage = query(baseQ, startAfter(prevLastDoc), limit(pageSize));
      const snap = await getDocs(qPage);
      const docs = snap.docs;
      setRows(docs.map((d) => ({ id: d.id, ...d.data() })));

      const last = docs.length ? docs[docs.length - 1] : null;
      const next = [...pageLastDocs];
      next[safeTarget - 1] = last;
      setPageLastDocs(next);

      setPage(safeTarget);
      setSelected({});
      setLoading(false);
      setPageLoading(false);
    } catch (e) {
      console.error("pagination fetchPage error:", e);
      setLoading(false);
      setPageLoading(false);
      toast.error(e?.code ? `Firestore: ${e.code}` : "Pagination page load failed. Check console.");
    }
  }

  // ✅ Reset to page 1 automatically on Search/Filter/PageSize change
  useEffect(() => {
    setPage(1);
  }, [search, statusFilter, pageSize, activeBatchId]);

  // ✅ When statusFilter/pageSize changes: refresh count + fetch page 1
  useEffect(() => {
    refreshCountAndPage1();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [statusFilter, pageSize, activeBatchId]);
  /* ================== FIX END: SERVER-SIDE PAGINATION QUERY BUILDER ================== */

  // ✅ FILTER + SORT (series order)
  const filtered = useMemo(() => {
    const s = search.trim().toLowerCase();
    const out = rows.filter((r) => {
      const okStatus = statusFilter === "ALL" ? true : r.outreachStatus === statusFilter;
      const blob = `${r.uniqueCode} ${r.societyName} ${r.district} ${r.taluka} ${r.village} ${r.mobile} ${r.email}`.toLowerCase();
      const okSearch = s ? blob.includes(s) : true;
      return okStatus && okSearch;
    });

    out.sort((a, b) => String(a.uniqueCode || "").localeCompare(String(b.uniqueCode || ""), "en", { numeric: true }));
    return out;
  }, [rows, search, statusFilter]);

  const selectedList = useMemo(() => rows.filter((r) => selected[r.id]), [rows, selected]);

  /* ================== FIX START: STATS CARDS REAL (NO MORE 0) ================== */
  const stats = useMemo(() => {
    return {
      total: statsCounts.total,
      applied: statsCounts.applied,
      pending: statsCounts.pending,
      emailQueuedOrSent: statsCounts.emailQueuedOrSent,
      courierSent: statsCounts.courierSent,
      unmatched: statsCounts.unmatched, // real count from getCountFromServer
    };
  }, [statsCounts]);
  /* ================== FIX END: STATS CARDS REAL (NO MORE 0) ================== */

  async function importCSV(file) {
    try {
      if (!file) return;
      const name = file.name.toLowerCase();
      if (!name.endsWith(".csv")) return toast.error("Upload CSV only (Excel -> Save As -> CSV)");

      const text = await file.text();
      const parsed = parseCSV(text);
      if (parsed.length < 2) return toast.error("CSV invalid/empty");

      const header = parsed[0].map((h) => String(h || "").trim().toLowerCase());
      const idx = (k) => header.indexOf(k);

      const idxName = idx("societyname") >= 0 ? idx("societyname") : idx("name");
      const idxAddr = idx("address");
      const idxVillage = idx("village");
      const idxTaluka = idx("taluka");
      const idxDistrict = idx("district");
      const idxMobile = idx("mobile");
      const idxEmail = idx("email");

      if (idxName < 0 || idxDistrict < 0) return toast.error("CSV must have SocietyName/Name and District.");

      const cleaned = parsed.slice(1).map((r) => ({
        societyName: String(r[idxName] || "").trim(),
        address: idxAddr >= 0 ? String(r[idxAddr] || "").trim() : "",
        village: idxVillage >= 0 ? String(r[idxVillage] || "").trim() : "",
        taluka: idxTaluka >= 0 ? String(r[idxTaluka] || "").trim() : "",
        district: String(r[idxDistrict] || "").trim(),
        mobile: idxMobile >= 0 ? String(r[idxMobile] || "").replace(/\D/g, "").slice(0, 10) : "",
        email: idxEmail >= 0 ? String(r[idxEmail] || "").trim() : "",
      })).filter((x) => x.societyName && x.district);

      if (!cleaned.length) return toast.error("No valid rows found");

      toast.loading("Importing CSV… (replace mode)", { id: "import" });

      const batchDoc = await addDoc(collection(db, "outreach_import_batches"), {
        filename: file.name,
        totalRows: cleaned.length,
        createdAt: serverTimestamp(),
      });
      const newBatchId = batchDoc.id;

      if (activeBatchId) await deleteRecipientsByBatchId(activeBatchId);

      await updateDoc(doc(db, "series", "outreach_active_csv"), {
        activeBatchId: newBatchId,
        updatedAt: serverTimestamp(),
      }).catch(async () => {
        await runTransaction(db, async (tx) => {
          tx.set(doc(db, "series", "outreach_active_csv"),
            { activeBatchId: newBatchId, updatedAt: serverTimestamp() },
            { merge: true }
          );
        });
      });

      const codes = await getNextRecipientCodeBatch(cleaned.length);
      const now = serverTimestamp();

      let ptr = 0;
      while (ptr < cleaned.length) {
        const chunk = cleaned.slice(ptr, ptr + 450);
        const wb = writeBatch(db);

        chunk.forEach((x, i) => {
          wb.set(doc(collection(db, "outreach_recipients")), {
            uniqueCode: codes[ptr + i],
            ...x,
            sourceBatchId: newBatchId,
            outreachStatus: "NOT_CONTACTED",
            emailQueuedAt: null,
            emailSentAt: null,
            courierSentAt: null,
            courierRefNo: "",
            appliedApplicationId: "",
            appliedAt: null,
            notes: "",
            createdAt: now,
            updatedAt: now,
          });
        });

        await wb.commit();
        ptr += chunk.length;
      }

      toast.success(`Imported ${cleaned.length} records`, { id: "import" });

      /* ================== FIX START: REFRESH PAGINATION AFTER IMPORT ================== */
      refreshCountAndPage1();
      /* ================== FIX END: REFRESH PAGINATION AFTER IMPORT ================== */
    } catch (e) {
      console.error("CSV import error:", e);
      toast.error(e?.code ? `Firestore: ${e.code}` : "CSV import failed. Check console.", { id: "import" });
    }
  }

  async function deleteBatch(batchId) {
    const ok = window.confirm("Are you sure? This will delete this CSV batch AND all recipients imported from it.");
    if (!ok) return;

    toast.loading("Deleting batch + data…", { id: "delbatch" });

    await deleteRecipientsByBatchId(batchId);
    await deleteDoc(doc(db, "outreach_import_batches", batchId));

    if (activeBatchId === batchId) {
      await updateDoc(doc(db, "series", "outreach_active_csv"), {
        activeBatchId: "",
        updatedAt: serverTimestamp(),
      }).catch(() => {});
    }

    toast.success("Batch + data deleted", { id: "delbatch" });

    /* ================== FIX START: REFRESH PAGINATION AFTER DELETE BATCH ================== */
    refreshCountAndPage1();
    /* ================== FIX END: REFRESH PAGINATION AFTER DELETE BATCH ================== */
  }

  async function queueEmailsSelected() {
    if (!selectedList.length) return toast.error("Select at least 1 record");

    const batch = writeBatch(db);
    const now = serverTimestamp();

    for (const r of selectedList) {
      if (!r.email) continue;

      const subject = "World’s Largest Grain Storage Plan – PACS ગોડાઉન માટે ઓનલાઈન અરજી બાબત (GUJCOMASOL)";

      /* ================== FIX START: DUPLICATE TEMPLATE INSIDE FUNCTION (DISABLED SAFE) ================== */
      if (false) {
        /* ================== FIX START: FINAL LETTER EMAIL TEMPLATE ================== */
        const FINAL_LETTER_EMAIL_HTML = `
          <div> (duplicate template disabled)</div>
        `;
        function buildFinalLetterEmailHTML(r) {
          return FINAL_LETTER_EMAIL_HTML;
        }
        /* ================== FIX END: FINAL LETTER EMAIL TEMPLATE ================== */
      }
      /* ================== FIX END: DUPLICATE TEMPLATE INSIDE FUNCTION (DISABLED SAFE) ================== */

      const html = buildFinalLetterEmailHTML(r);
      const html_old = `
  <div style="font-family:Arial,sans-serif;font-size:14px;line-height:1.6;">
          <p><b>પ્રતિ, ${safeText(r.societyName || "")}</b></p>
          <p>
            ભારત સરકારની <b>World’s Largest Grain Storage Plan in Cooperative Sector</b> યોજના અંતર્ગત
            પાત્ર સહકારી સંસ્થાઓ દ્વારા ગોડાઉન માટે અરજી કરી શકાય છે.
          </p>
          <p>
            અરજી લિંક: <a href="https://www.shineagri.org/apply-godown">https://www.shineagri.org/apply-godown</a><br/>
            તમારો આમંત્રણ કોડ: <b>${safeText(r.uniqueCode)}</b>
          </p>
          <p>Coordination: <b>GUJCOMASOL</b> | PMC Handholding: <b>Shine Agri Allied</b></p>
          <p>Regards,<br/>GUJCOMASOL</p>
        </div>
      `;

      batch.set(doc(collection(db, "email_queue")), {
        type: "GODOWN_INVITE",
        toEmail: r.email,
        toName: r.societyName || "",
        subject,
        html,
        attachments: [],
        status: "pending",
        error: "",
        createdAt: now,
        sentAt: null,
      });

      const nextStatus =
        r.outreachStatus === "COURIER_SENT" ? "BOTH_SENT" :
        r.outreachStatus === "APPLIED" ? "APPLIED" :
        "EMAIL_QUEUED";

      batch.set(
  doc(db, "outreach_recipients", r.id),
  { outreachStatus: nextStatus, emailQueuedAt: now, updatedAt: now },
  { merge: true }
);
    }

    await batch.commit();
    toast.success("Emails queued (Functions will send).");

    /* ================== FIX START: AUTO REFRESH AFTER QUEUE EMAILS ================== */
    fetchPage(page);
    refreshStatsCounts();
    /* ================== FIX END: AUTO REFRESH AFTER QUEUE EMAILS ================== */
  }

  /* ================== FIX START: REJECT + MAIL (REASON) ================== */
  async function queueRejectEmail(r) {
    const reason = prompt("Reject reason (this will go in email):", "");
    if (reason == null) return;

    if (!r?.email) return toast.error("This record has no email");

    const nowD = new Date();
    const dd = String(nowD.getDate()).padStart(2, "0");
    const mm = String(nowD.getMonth() + 1).padStart(2, "0");
    const yyyy = nowD.getFullYear();
    const today = `${dd}/${mm}/${yyyy}`;

    const subject = `Application / Document Rejected – ${safeText(r.uniqueCode || "")} (GUJCOMASOL)`;

    const html = `
    <div style="font-family:Arial,Helvetica,sans-serif;font-size:14px;line-height:1.8;color:#111827;">
      <p><b>પ્રતિ,</b><br/>
      ચેરમેનશ્રી / સેક્રેટરીશ્રી / મેનેજરશ્રી,<br/>
      <b>${safeText(r.societyName || "")}</b></p>

      <p><b>તારીખ:</b> ${today}</p>

      <p>
        આપની અરજી/દસ્તાવેજોની પ્રાથમિક ચકાસણી દરમ્યાન નીચે મુજબ કારણસર
        <b style="color:#b91c1c;">REJECT / CLARIFICATION REQUIRED</b> કરવામાં આવે છે:
      </p>

      <div style="padding:10px 12px;border:1px solid #e5e7eb;border-radius:10px;background:#fff7ed;">
        <b>Reason:</b> ${safeText(reason)}
      </div>

      <p style="margin-top:10px;">
        કૃપા કરીને ઉપરોક્ત ખામીઓ સુધારી જરૂરી દસ્તાવેજો ફરીથી PMC પર મોકલવા વિનંતી.
      </p>

      <p>
        <b>PMC Email:</b> tender@shineagri.org<br/>
        <b>Helpline:</b> 9274799225 / 761869225
      </p>

      <p><b>આપનો વિશ્વાસુ,</b><br/>GUJCOMASOL</p>
    </div>
  `;

    await addDoc(collection(db, "email_queue"), {
      type: "GODOWN_REJECT",
      toEmail: r.email,
      toName: r.societyName || "",
      subject,
      html,
      attachments: [],
      status: "pending",
      error: "",
      createdAt: serverTimestamp(),
      sentAt: null,
    });

    await updateDoc(doc(db, "outreach_recipients", r.id), {
      outreachStatus: "FOLLOWUP_REQUIRED",
      notes: `REJECT REASON (${today}): ${safeText(reason)}\n${safeText(r.notes || "")}`,
      updatedAt: serverTimestamp(),
    });

    toast.success("Reject mail queued with reason.");

    /* ================== FIX START: AUTO REFRESH AFTER REJECT + MAIL ================== */
    fetchPage(page);
    refreshStatsCounts();
    /* ================== FIX END: AUTO REFRESH AFTER REJECT + MAIL ================== */
  }
  /* ================== FIX END: REJECT + MAIL (REASON) ================== */

  async function downloadLettersZip() {
    if (!selectedList.length) return toast.error("Select at least 1 record");

    toast.loading("Generating PDFs…", { id: "zip" });

    const zip = new JSZip();
    for (const r of selectedList) {
      const blob = await makeGujaratiLetterPDF_Canvas(r);
      const safeName = (r.societyName || r.uniqueCode).replace(/[^\w\- ]+/g, "").slice(0, 60);
      zip.file(`${r.uniqueCode}_${safeName}.pdf`, blob);
    }

    const out = await zip.generateAsync({ type: "blob" });
    saveAs(out, `GUJCOMASOL_Godown_Letters_${Date.now()}.zip`);
    toast.success("ZIP downloaded", { id: "zip" });
  }

  async function markCourierSent(recId) {
    const refNo = prompt("Courier Ref No (optional):", "");
    await updateDoc(doc(db, "outreach_recipients", recId), {
      outreachStatus: "COURIER_SENT",
      courierRefNo: (refNo || "").trim(),
      courierSentAt: serverTimestamp(),
      updatedAt: serverTimestamp(),
    });
    toast.success("Marked courier sent");

    /* ================== FIX START: REFRESH CURRENT PAGE AFTER UPDATE ================== */
    fetchPage(page);
    refreshStatsCounts();
    /* ================== FIX END: REFRESH CURRENT PAGE AFTER UPDATE ================== */
  }

  async function deleteRecipient(rec) {
    const ok = window.confirm(`Delete this record?\n\n${rec.uniqueCode} - ${rec.societyName}`);
    if (!ok) return;

    await deleteDoc(doc(db, "outreach_recipients", rec.id));
    toast.success("Deleted");

    /* ================== FIX START: REFRESH PAGINATION AFTER DELETE RECORD ================== */
    refreshCountAndPage1();
    /* ================== FIX END: REFRESH PAGINATION AFTER DELETE RECORD ================== */
  }

  function exportReportCSV() {
    const reportRows = [
      ["Metric", "Count"],
      ["Total", stats.total],
      ["Applied", stats.applied],
      ["Pending", stats.pending],
      ["Email Queued/Sent", stats.emailQueuedOrSent],
      ["Courier Sent", stats.courierSent],
      ["Unmatched Applications", stats.unmatched],
    ];
    downloadCSV(`outreach_report_${Date.now()}.csv`, reportRows);
    toast.success("Report CSV downloaded");
  }

  function openEdit(rec) {
    setEditRow({
      id: rec.id,
      uniqueCode: rec.uniqueCode || "",
      societyName: rec.societyName || "",
      address: rec.address || "",
      village: rec.village || "",
      taluka: rec.taluka || "",
      district: rec.district || "",
      mobile: rec.mobile || "",
      email: rec.email || "",
      outreachStatus: rec.outreachStatus || "NOT_CONTACTED",
      notes: rec.notes || "",
    });
    setEditOpen(true);
  }

  async function saveEdit() {
    if (!editRow?.id) return;

    const payload = {
      societyName: safeText(editRow.societyName),
      address: safeText(editRow.address),
      village: safeText(editRow.village),
      taluka: safeText(editRow.taluka),
      district: safeText(editRow.district),
      mobile: safeText(editRow.mobile).replace(/\D/g, "").slice(0, 10),
      email: safeText(editRow.email),
      outreachStatus: editRow.outreachStatus,
      notes: safeText(editRow.notes),
      updatedAt: serverTimestamp(),
    };

    await updateDoc(doc(db, "outreach_recipients", editRow.id), payload);
    toast.success("Updated");
    setEditOpen(false);
    setEditRow(null);

    /* ================== FIX START: REFRESH CURRENT PAGE AFTER EDIT ================== */
    fetchPage(page);
    refreshStatsCounts();
    /* ================== FIX END: REFRESH CURRENT PAGE AFTER EDIT ================== */
  }

  /* ================== FIX START: JUMP BUTTONS WINDOW (1,2,3...) ================== */
  const jumpButtons = useMemo(() => {
    const pc = pageCount || 1;
    const p = page || 1;
    const out = [];

    const push = (x) => out.push(x);

    if (pc <= 9) {
      for (let i = 1; i <= pc; i++) push(i);
      return out;
    }

    // Always show first 2, last 2, and around current
    const set = new Set([1, 2, pc - 1, pc, p - 1, p, p + 1]);
    const arr = Array.from(set)
      .filter((n) => n >= 1 && n <= pc)
      .sort((a, b) => a - b);

    let prev = null;
    for (const n of arr) {
      if (prev != null && n - prev > 1) push("…");
      push(n);
      prev = n;
    }
    return out;
  }, [pageCount, page]);
  /* ================== FIX END: JUMP BUTTONS WINDOW (1,2,3...) ================== */

  return (
    <>
      <Toaster position="top-center" />

      <div className="min-h-screen bg-gradient-to-br from-slate-50 via-white to-emerald-50 py-8">
        <div className="max-w-7xl mx-auto px-3 md:px-6">
          <div className="rounded-[28px] bg-white border border-slate-200 shadow-[0_28px_80px_rgba(2,6,23,0.10)] p-6 md:p-8">

            {/* ✅ PREMIUM HEADER WITH GUJCOMASOL */}
            <div className="flex flex-col gap-4 md:flex-row md:items-center md:justify-between border-b border-slate-200 pb-5">
              <div className="flex items-center gap-3">
                <div className="h-12 w-12 rounded-2xl bg-emerald-700 text-white flex items-center justify-center font-black">
                  G
                </div>
                <div>
                  <div className="text-[11px] font-black uppercase tracking-[0.22em] text-emerald-700">
                    GUJCOMASOL • FINAL AUTOMATION DASHBOARD
                  </div>
                  <h1 className="mt-1 text-2xl md:text-3xl font-black text-slate-900 leading-tight">
                    Outreach + Applied Verification + Reports
                  </h1>
                  <p className="mt-1 text-[12px] text-slate-600">
                    CSV Import (replace mode) → Letters ZIP → Queue Emails → Status Tracking → Unmatched
                  </p>
                </div>
              </div>

              <div className="flex flex-wrap gap-2 md:justify-end">
                <label className="rounded-full bg-emerald-700 text-white px-4 py-2 text-sm font-black cursor-pointer hover:bg-emerald-800">
                  Import CSV
                  <input type="file" accept=".csv" className="hidden" onChange={(e) => importCSV(e.target.files?.[0])} />
                </label>

                <button onClick={downloadLettersZip} className="rounded-full bg-slate-900 text-white px-4 py-2 text-sm font-black hover:bg-black">
                  Download Letters ZIP
                </button>

                <button onClick={queueEmailsSelected} className="rounded-full bg-blue-700 text-white px-4 py-2 text-sm font-black hover:bg-blue-800">
                  Queue Emails
                </button>

                <button onClick={exportReportCSV} className="rounded-full bg-indigo-700 text-white px-4 py-2 text-sm font-black hover:bg-indigo-800">
                  Download Report CSV
                </button>
              </div>
            </div>

            {/* CSV Batches */}
            <div className="mt-6 rounded-2xl border border-slate-200 bg-slate-50 p-4">
              <div className="flex items-center justify-between gap-3 flex-wrap">
                <div>
                  <div className="text-xs font-black text-slate-900">Uploaded CSV History (Saved in Firestore)</div>
                  <div className="text-[12px] text-slate-600 mt-1">
                    New CSV upload automatically <b>replaces old active CSV data</b>. Delete any batch to remove its imported data.
                  </div>
                </div>
                <div className="text-[12px] font-black">
                  Active Batch:{" "}
                  <span className="font-mono px-2 py-1 rounded-lg border border-slate-300 bg-white">
                    {activeBatchId || "—"}
                  </span>
                </div>
              </div>

              <div className="mt-3 overflow-x-auto rounded-xl border-2 border-black bg-white">
                <table className="min-w-[900px] w-full text-sm border-collapse">
                  <thead className="bg-white">
                    <tr className="text-[12px] text-black">
                      <th className="p-3 text-left font-black border-b-2 border-black border-r-2 border-black">Batch ID</th>
                      <th className="p-3 text-left font-black border-b-2 border-black border-r-2 border-black">Filename</th>
                      <th className="p-3 text-left font-black border-b-2 border-black border-r-2 border-black">Rows</th>
                      <th className="p-3 text-left font-black border-b-2 border-black border-r-2 border-black">Status</th>
                      <th className="p-3 text-left font-black border-b-2 border-black">Action</th>
                    </tr>
                  </thead>
                  <tbody>
                    {batches.length === 0 ? (
                      <tr><td colSpan={5} className="p-4 text-slate-600">No CSV uploads yet.</td></tr>
                    ) : (
                      batches.map((b) => (
                        <tr key={b.id} className="border-b-2 border-black">
                          <td className="p-3 font-mono text-[12px] border-r-2 border-black">{b.id}</td>
                          <td className="p-3 border-r-2 border-black">{b.filename || "—"}</td>
                          <td className="p-3 border-r-2 border-black">{b.totalRows || 0}</td>
                          <td className="p-3 border-r-2 border-black">
                            {activeBatchId === b.id ? (
                              <span className="px-2 py-1 text-[12px] font-black rounded-full bg-emerald-100 border-2 border-black">ACTIVE</span>
                            ) : (
                              <span className="px-2 py-1 text-[12px] font-black rounded-full bg-slate-100 border-2 border-black">ARCHIVED</span>
                            )}
                          </td>
                          <td className="p-3">
                            <button className="px-3 py-1.5 rounded-full text-[12px] font-black bg-rose-600 text-white hover:bg-rose-700" onClick={() => deleteBatch(b.id)}>
                              Delete Batch + Data
                            </button>
                          </td>
                        </tr>
                      ))
                    )}
                  </tbody>
                </table>
              </div>
            </div>

            {/* Stats Cards */}
            <div className="mt-6 grid grid-cols-2 md:grid-cols-6 gap-2 text-xs">
              {[
                { label: "Total", value: stats.total, tone: "bg-white border-black text-black" },
                { label: "Applied", value: stats.applied, tone: "bg-emerald-50 border-black text-emerald-900" },
                { label: "Pending", value: stats.pending, tone: "bg-amber-50 border-black text-amber-900" },
                { label: "Email Q/S", value: stats.emailQueuedOrSent, tone: "bg-blue-50 border-black text-blue-900" },
                { label: "Courier", value: stats.courierSent, tone: "bg-indigo-50 border-black text-indigo-900" },
                { label: "Unmatched", value: stats.unmatched, tone: "bg-rose-50 border-black text-rose-900" },
              ].map((c) => (
                <div key={c.label} className={cx("rounded-2xl px-3 py-2 border-2 shadow-sm", c.tone)}>
                  <div className="font-black">{c.label}</div>
                  <div className="text-[15px] font-black">{c.value}</div>
                </div>
              ))}
            </div>

            {/* Search/Filter */}
            <div className="mt-5 grid gap-3 md:grid-cols-2">
              <div>
                <div className="text-xs font-black text-slate-800">Search</div>
                <input
                  value={search}
                  onChange={(e) => setSearch(e.target.value)}
                  placeholder="Search name / district / mobile / email / code"
                  className="mt-1 w-full rounded-xl border-2 border-black/20 px-4 py-2.5 text-sm"
                />
              </div>
              <div>
                <div className="text-xs font-black text-slate-800">Filter</div>
                <select
                  value={statusFilter}
                  onChange={(e) => setStatusFilter(e.target.value)}
                  className="mt-1 w-full rounded-xl border-2 border-black/20 px-4 py-2.5 text-sm"
                >
                  <option value="ALL">ALL</option>
                  {STATUS_OPTIONS.map((s) => (
  <option key={s} value={s}>{String(s || "").replaceAll("_", " ")}</option>
))}
                </select>
              </div>
            </div>

            {/* ================== FIX START: PAGE SIZE DROPDOWN (10/25/50) ================== */}
            <div className="mt-4 flex flex-wrap items-center justify-between gap-3">
              <div className="flex items-center gap-3">
                <div className="text-xs font-black text-slate-800">Page Size</div>
                <select
                  value={pageSize}
                  onChange={(e) => setPageSize(Number(e.target.value || 10))}
                  className="rounded-xl border-2 border-black/20 px-3 py-2 text-sm font-black bg-white"
                >
                  <option value={10}>10</option>
                  <option value={25}>25</option>
                  <option value={50}>50</option>
                </select>

                <div className="text-[12px] text-slate-700">
                  Page <b>{page}</b> / <b>{pageCount}</b> • Total <b>{totalCount}</b>
                </div>
              </div>

              <div className="flex items-center gap-2">
                <button
                  disabled={page <= 1 || pageLoading}
                  onClick={() => fetchPage(page - 1)}
                  className={cx(
                    "px-4 py-2 rounded-full text-[12px] font-black border-2 border-black",
                    page <= 1 || pageLoading ? "bg-slate-100 text-slate-400 cursor-not-allowed" : "bg-white hover:bg-slate-50"
                  )}
                >
                  Prev
                </button>

                <button
                  disabled={page >= pageCount || pageLoading}
                  onClick={() => fetchPage(page + 1)}
                  className={cx(
                    "px-4 py-2 rounded-full text-[12px] font-black border-2 border-black",
                    page >= pageCount || pageLoading ? "bg-slate-100 text-slate-400 cursor-not-allowed" : "bg-white hover:bg-slate-50"
                  )}
                >
                  Next
                </button>
              </div>
            </div>

            <div className="mt-3 flex flex-wrap gap-2">
              {jumpButtons.map((x, i) => (
                x === "…" ? (
                  <span key={`dots_${i}`} className="px-3 py-2 text-[12px] font-black text-slate-500">…</span>
                ) : (
                  <button
                    key={`p_${x}`}
                    disabled={pageLoading}
                    onClick={() => fetchPage(Number(x))}
                    className={cx(
                      "px-3 py-2 rounded-full text-[12px] font-black border-2 border-black",
                      Number(x) === page ? "bg-black text-white" : "bg-white hover:bg-slate-50"
                    )}
                  >
                    {x}
                  </button>
                )
              ))}
            </div>
            {/* ================== FIX END: PAGE SIZE DROPDOWN (10/25/50) ================== */}

            {/* ✅ TABLE FULL BLACK GRID + S.No. */}
            <div className="mt-6 overflow-x-auto rounded-2xl border-2 border-black bg-white">
              <table className="min-w-[1350px] w-full text-sm border-collapse">
                <thead className="bg-white">
                  <tr className="text-[12px] text-black">
                    <th className="p-3 text-left font-black border-b-2 border-black border-r-2 border-black">
                      <input
                        type="checkbox"
                        onChange={(e) => {
                          const checked = e.target.checked;
                          const next = {};
                          filtered.forEach((r) => (next[r.id] = checked));
                          setSelected(next);
                        }}
                      />
                    </th>
                    <th className="p-3 text-left font-black border-b-2 border-black border-r-2 border-black">S.No.</th>
                    <th className="p-3 text-left font-black border-b-2 border-black border-r-2 border-black">Code</th>
                    <th className="p-3 text-left font-black border-b-2 border-black border-r-2 border-black">Society</th>
                    <th className="p-3 text-left font-black border-b-2 border-black border-r-2 border-black">District/Taluka/Village</th>
                    <th className="p-3 text-left font-black border-b-2 border-black border-r-2 border-black">Mobile/Email</th>
                    <th className="p-3 text-left font-black border-b-2 border-black border-r-2 border-black">Status</th>
                    <th className="p-3 text-left font-black border-b-2 border-black">Actions</th>
                  </tr>
                </thead>

                <tbody>
                  {(loading || pageLoading) && (
                    <tr><td className="p-4 text-slate-600" colSpan={8}>Loading…</td></tr>
                  )}
                  {!loading && !pageLoading && filtered.length === 0 && (
                    <tr><td className="p-4 text-slate-600" colSpan={8}>No records</td></tr>
                  )}

                  {filtered.map((r, idx) => (
                    <tr key={r.id} className="border-b-2 border-black hover:bg-emerald-50/40">
                      <td className="p-3 align-top border-r-2 border-black">
                        <input
                          type="checkbox"
                          checked={!!selected[r.id]}
                          onChange={(e) => setSelected((p) => ({ ...p, [r.id]: e.target.checked }))}
                        />
                      </td>

                      {/* ================== FIX START: S.NO. WHOLE DATASET ================== */}
                      <td className="p-3 align-top font-black border-r-2 border-black">{(page - 1) * pageSize + idx + 1}</td>
                      {/* ================== FIX END: S.NO. WHOLE DATASET ================== */}

                      <td className="p-3 align-top font-mono text-[12px] border-r-2 border-black">
                        {r.uniqueCode}
                        {r.sourceBatchId && (
                          <div className="mt-1 text-[11px] text-slate-500">
                            Batch: <span className="font-mono">{r.sourceBatchId}</span>
                          </div>
                        )}
                      </td>

                      <td className="p-3 align-top border-r-2 border-black">
                        <div className="font-black text-slate-900">{r.societyName}</div>
                        {r.address ? <div className="text-[12px] text-slate-600 mt-1">{r.address}</div> : null}
                        {r.appliedApplicationId ? <div className="text-[12px] text-emerald-800 font-black mt-1">Applied: {r.appliedApplicationId}</div> : null}
                      </td>

                      <td className="p-3 align-top text-[12px] text-slate-800 border-r-2 border-black">
                        <div className="font-black">{r.district || "—"}</div>
                        <div className="mt-1">{r.taluka || "—"}{r.village ? ` • ${r.village}` : ""}</div>
                      </td>

                      <td className="p-3 align-top text-[12px] border-r-2 border-black">
                        <div className="font-black">{r.mobile || "—"}</div>
                        <div className="text-slate-600">{r.email || "—"}</div>
                      </td>

                      <td className="p-3 align-top text-[12px] border-r-2 border-black">
                        <span className="px-2 py-1 rounded-full border-2 border-black bg-slate-50 font-black">
                          {r.outreachStatus || "NOT_CONTACTED"}
                        </span>
                      </td>

                      <td className="p-3 align-top">
                        <div className="flex flex-wrap gap-2">
                          <button
                            type="button"
                            onClick={() => markCourierSent(r.id)}
                            className="px-3 py-1.5 rounded-full text-[12px] font-black bg-amber-500 text-white hover:bg-amber-600"
                          >
                            Mark Courier
                          </button>

                          <button
                            type="button"
                            onClick={() => openEdit(r)}
                            className="px-3 py-1.5 rounded-full text-[12px] font-black bg-blue-700 text-white hover:bg-blue-800"
                          >
                            Edit
                          </button>

                          <button
                            type="button"
                            onClick={() => queueRejectEmail(r)}
                            className="px-3 py-1.5 rounded-full text-[12px] font-black bg-red-700 text-white hover:bg-red-800"
                          >
                            Reject + Mail
                          </button>

                          <button
                            type="button"
                            onClick={() => deleteRecipient(r)}
                            className="px-3 py-1.5 rounded-full text-[12px] font-black bg-rose-600 text-white hover:bg-rose-700"
                          >
                            Delete
                          </button>

                          <button
                            type="button"
                            onClick={async () => {
                              const n = prompt("Notes:", r.notes || "");
                              if (n == null) return;
                              await updateDoc(doc(db, "outreach_recipients", r.id), {
                                notes: n,
                                updatedAt: serverTimestamp(),
                              });
                              toast.success("Notes saved");
                              fetchPage(page);
                              refreshStatsCounts();
                            }}
                            className="px-3 py-1.5 rounded-full text-[12px] font-black bg-slate-100 text-slate-800 border-2 border-black hover:bg-slate-200"
                          >
                            Notes
                          </button>
                        </div>
                      </td>
                    </tr>
                  ))}
                </tbody>

              </table>
            </div>

          </div>
        </div>
      </div>

      {/* Unmatched / Direct Applications */}
      <div className="mt-4 rounded-3xl border-2 border-black bg-rose-50/60 p-5">
        <div className="text-[11px] font-black uppercase tracking-[0.18em] text-rose-700">
          DIRECT / UNMATCHED APPLICATIONS
        </div>

        <div className="mt-1 text-lg font-black text-slate-900">
          Applications received without matching outreach list
        </div>

        <div className="mt-1 text-[12px] text-slate-700">
          These people applied directly OR details didn’t match (mobile/email/code).
        </div>

        <div className="mt-4 overflow-x-auto rounded-2xl border-2 border-black bg-white">
          <table className="min-w-[1100px] w-full text-sm border-collapse">
            <thead className="bg-white">
              <tr className="text-[12px] text-black">
                <th className="p-3 text-left font-black border-b-2 border-black border-r-2 border-black">
                  Application ID
                </th>
                <th className="p-3 text-left font-black border-b-2 border-black border-r-2 border-black">
                  Name
                </th>
                <th className="p-3 text-left font-black border-b-2 border-black border-r-2 border-black">
                  District / Taluka / Village
                </th>
                <th className="p-3 text-left font-black border-b-2 border-black border-r-2 border-black">
                  Mobile / Email
                </th>
                <th className="p-3 text-left font-black border-b-2 border-black">
                  Reason
                </th>
              </tr>
            </thead>

            <tbody>
              {unmatched.length === 0 ? (
                <tr className="border-b-2 border-black">
                  <td className="p-4 text-slate-700" colSpan={5}>
                    No unmatched applications 🎉
                  </td>
                </tr>
              ) : (
                unmatched.map((u) => (
                  <tr key={u.id} className="border-b-2 border-black hover:bg-rose-50/40">
                    <td className="p-3 font-mono text-[12px] border-r-2 border-black">
                      {u.applicationId || u.id}
                    </td>

                    <td className="p-3 border-r-2 border-black">
                      <div className="font-black text-slate-900">{u.pacsName || "—"}</div>
                      <div className="text-[12px] text-slate-600">{u.contactName || ""}</div>
                    </td>

                    <td className="p-3 text-[12px] text-slate-800 border-r-2 border-black">
                      <div className="font-black">{u.district || "—"}</div>
                      <div className="mt-1">
                        {u.taluka || "—"}
                        {u.village ? ` • ${u.village}` : ""}
                      </div>
                    </td>

                    <td className="p-3 text-[12px] text-slate-800 border-r-2 border-black">
                      <div className="font-black">{u.contactPhone || "—"}</div>
                      <div className="text-slate-600">{u.contactEmail || "—"}</div>
                    </td>

                    <td className="p-3 text-[12px]">
                      <span className="px-2 py-1 rounded-full bg-rose-100 border-2 border-black text-rose-900 font-black">
                        {u.source || "UNMATCHED"}
                      </span>
                    </td>
                  </tr>
                ))
              )}
            </tbody>
          </table>
        </div>

        <div className="mt-3 text-[11px] text-slate-700">
          Tip: Invite Code field add करने से unmatched बहुत कम हो जाएंगे.
        </div>
      </div>

      {/* EDIT MODAL */}
      {editOpen && editRow && (
        <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/55 p-3">
          <div className="w-full max-w-3xl rounded-3xl bg-white border-2 border-black shadow-2xl p-5">
            <div className="flex items-start justify-between gap-3">
              <div>
                <div className="text-xs font-black text-slate-700">Edit Recipient</div>
                <div className="mt-1 text-xl font-black text-slate-900">{editRow.uniqueCode}</div>
              </div>
              <button className="px-3 py-2 rounded-xl border-2 border-black font-black hover:bg-slate-100" onClick={() => { setEditOpen(false); setEditRow(null); }}>
                Close
              </button>
            </div>

            <div className="mt-4 grid grid-cols-1 md:grid-cols-2 gap-3">
              <Field label="Society Name" value={editRow.societyName} onChange={(v) => setEditRow((p) => ({ ...p, societyName: v }))} />
              <Field label="District" value={editRow.district} onChange={(v) => setEditRow((p) => ({ ...p, district: v }))} />
              <Field label="Taluka" value={editRow.taluka} onChange={(v) => setEditRow((p) => ({ ...p, taluka: v }))} />
              <Field label="Village" value={editRow.village} onChange={(v) => setEditRow((p) => ({ ...p, village: v }))} />
              <Field label="Mobile" value={editRow.mobile} onChange={(v) => setEditRow((p) => ({ ...p, mobile: v }))} />
              <Field label="Email" value={editRow.email} onChange={(v) => setEditRow((p) => ({ ...p, email: v }))} />
              <div className="md:col-span-2">
                <Field label="Address" value={editRow.address} onChange={(v) => setEditRow((p) => ({ ...p, address: v }))} textarea />
              </div>

              <div className="md:col-span-2">
                <div className="text-xs font-black text-slate-800">Status</div>
                <select
                  value={editRow.outreachStatus}
                  onChange={(e) => setEditRow((p) => ({ ...p, outreachStatus: e.target.value }))}
                  className="mt-1 w-full rounded-xl border-2 border-black/20 px-4 py-2.5 text-sm"
                >
                  {STATUS_OPTIONS.map((s) => (
  <option key={s} value={s}>{String(s || "").replaceAll("_", " ")}</option>
))}
                </select>
              </div>

              <div className="md:col-span-2">
                <Field label="Notes" value={editRow.notes} onChange={(v) => setEditRow((p) => ({ ...p, notes: v }))} textarea />
              </div>
            </div>

            <div className="mt-5 flex justify-end">
              <button className="px-5 py-2.5 rounded-full bg-slate-900 text-white font-black hover:bg-black" onClick={saveEdit}>
                Save Changes
              </button>
            </div>
          </div>
        </div>
      )}
    </>
  );
}

/** Small Field component */
function Field({ label, value, onChange, textarea }) {
  return (
    <div>
      <div className="text-xs font-black text-slate-800">{label}</div>
      {textarea ? (
        <textarea
          value={value}
          onChange={(e) => onChange(e.target.value)}
          className="mt-1 w-full rounded-xl border-2 border-black/20 px-4 py-2.5 text-sm min-h-[90px]"
        />
      ) : (
        <input
          value={value}
          onChange={(e) => onChange(e.target.value)}
          className="mt-1 w-full rounded-xl border-2 border-black/20 px-4 py-2.5 text-sm"
        />
      )}
    </div>
  );
}

/* =========================================================
   NOTE:
   Aapke original code me downloadCSV same name 2 baar tha.
   Maine second wala delete nahi kiya — run error avoid ke liye use comment rakha.
   ========================================================= */

// function downloadCSV(filename, rows) {
//   const escape = (v) => {
//     const s = String(v ?? "");
//     if (s.includes(",") || s.includes('"') || s.includes("\n")) {
//       return `"${s.replaceAll('"', '""')}"`;
//     }
//     return s;
//   };
//   const csv = rows.map((r) => r.map(escape).join(",")).join("\n");
//   const blob = new Blob([csv], { type: "text/csv;charset=utf-8" });
//   saveAs(blob, filename);
// }
